// §8.3 / §2.7 領料判定。by_id 與 by_weight 的差異是 mockup 要示範的第二個重點。
import { homogeneityOf } from './world.js';
export function judgePick(world, config, item, splitBasis, pickedPanelIds) {
    const isPartial = pickedPanelIds.length > 0 && pickedPanelIds.length < item.panelIds.length;
    const panels = pickedPanelIds.length > 0 ? pickedPanelIds : item.panelIds;
    const homogeneityGrade = homogeneityOf(world, panels);
    const models = new Set(panels.map((p) => world.panels.get(p)?.modelCode ?? '未辨識'));
    const homogeneityReason = homogeneityGrade === 'A'
        ? `單一型號（${[...models][0] ?? '—'}）`
        : `${models.size} 種型號混批：${[...models].join('、')}`;
    let resolutionGrade;
    let resolutionReason;
    let needsApproval = false;
    let approvalRule = 'preapproved';
    let splitNote;
    let degraded = false;
    if (item.r3Taint) {
        resolutionGrade = 'R3';
        resolutionReason = '來源料件曾以重量切分，分攤已跨集合';
        needsApproval = true;
        approvalRule = 'case_by_case';
        splitNote = '本料件已帶 R3 汙染，無論怎麼領都無法回到 R2';
        degraded = true;
    }
    else if (!isPartial) {
        resolutionGrade = item.resolutionGrade === 'R1' ? 'R1' : 'R2';
        resolutionReason = resolutionGrade === 'R1'
            ? '整件領出，且每片已有實測重量'
            : '整件領出，集合完整未分裂';
        splitNote = '整件領出 — 不分裂，不降級';
    }
    else if (splitBasis === 'by_id') {
        resolutionGrade = item.resolutionGrade === 'R1' ? 'R1' : 'R2';
        resolutionReason = resolutionGrade === 'R1'
            ? '按 PV 號挑選，且每片已有實測重量'
            : '按 PV 號挑選，每片完整歸屬一邊';
        splitNote = 'by_id — 每片完整歸屬一邊，不降級';
    }
    else {
        resolutionGrade = 'R3';
        resolutionReason = '按重量切分，分攤跨集合邊界';
        needsApproval = true;
        approvalRule = 'case_by_case';
        splitNote = 'by_weight — 分攤跨集合，對不到實體';
        degraded = true;
    }
    if (homogeneityGrade === 'C' && !needsApproval) {
        needsApproval = true;
        approvalRule = 'case_by_case';
    }
    return {
        resolutionGrade, resolutionReason, homogeneityGrade, homogeneityReason,
        needsApproval, approvalRule, splitNote, degraded,
    };
}
//# sourceMappingURL=resolution.js.map